import { createNamespacedHelpers } from "vuex";
const userVuex = createNamespacedHelpers("user");
const taskVuex = createNamespacedHelpers("task");
export default {
  name: "membershipFan",
  computed: {
    ...userVuex.mapState(["userInfo", "settingInfo", "isLogin", "userCardInfo"]),
    ...taskVuex.mapState(["taskInfo"])
  },
  data() {
    const infoList = [{
      label: "Star Interaction",
      icon: require(`@images/${this.aiSkin}/fan-icon-inter.png`),
      children: ["AI Text Chat", "AI Voice Chat", "Event Access"],
      intro: ["1、Star AI Text Interaction", "2、Star AI Voice Interaction", "3、Priority Reservation for Star Events"]
    }, {
      label: "Web3 Digital Assets",
      icon: require(`@images/${this.aiSkin}/fan-icon-web3.png`),
      children: ["Token Airdrop", "NFT Airdrop", "Limited Editions"],
      intro: ["1、Exclusive Meme Token Airdrops", "2、Star-themed NFTs (Cards, Signature Cards, Perk Cards)", "3、Limited Digital Collectibles"]
    }, {
      label: "Virtual Collectibles",
      icon: require(`@images/${this.aiSkin}/fan-icon-vir.png`),
      children: ["Digital Photo", "AI Selfies", "E-Signatures"],
      intro: ["1、Digital Photos of the Star", "2、AI-generated Photo with Star & Digital Signature", "3、Collectible Fan Memories"]
    }, {
      label: "Star Picks & Gifts",
      icon: require(`@images/${this.aiSkin}/fan-icon-gift.png`),
      children: ["Free Gifts", "Curated Boxes", "Star Merch"],
      intro: ["1、Free access to limited-edition items recommended by the star", "2、Exclusive Gift Boxes handpicked by the star", "3、Exclusive Star Merch"]
    }, {
      label: "VIP Exclusive Benefits",
      icon: require(`@images/${this.aiSkin}/fan-icon-vip.png`),
      children: ["1-on-1 Voice", "Event Priority", "Signed Photo", "Exclusive Content"],
      intro: ["1、1-on-1 Voice Interaction (Human)", "2、Priority Access to Star Meetups", "3、Limited Edition Signed Photo", "4、Unlock Exclusive Content (Behind scenes, Private Voice)"]
    }];
    return {
      infoList,
      popFanIntroShow: false,
      popFanIntro: {
        icon: null,
        title: "123"
      }
    };
  },
  watch: {
    isLogin: {
      async handler(bool) {
        if (bool) {}
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    ...userVuex.mapActions(["getCardPriceInfo", "buyCard", "getUserRights", "buyCardCredits"]),
    onFanIntroShow(item) {
      const popFanIntro = {
        title: item.label,
        icon: item.icon,
        intro: item.intro
      };
      this.popFanIntro = popFanIntro;
      this.popFanIntroShow = true;
    },
    onShare() {
      this.shareFn();
    }
  }
};